import { styled } from "@mui/material";

export const Styled = {
    Container: styled("div")`
        display: flex;
        align-items: center;
        gap: 6px;
    `,
};
